/**
 * Configuración de AWS Amplify
 *
 * Valores = User Pool PROPIO de Citame (stack whatsapp-scheduler-dev, NER-1457).
 * NO reusa el pool de Resto. Outputs de CloudFormation:
 * CitameUserPool / CitameUserPoolClient. Region us-east-1.
 * Los fallbacks hardcodeados son los outputs dev; en prod los pisa el .env.
 */

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_H0PzgUfZz',
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '52g6u9qg1u5jec8etmcu608r6s',
      region: 'us-east-1',
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
      },
      userAttributes: {
        email: {
          required: true,
        },
        name: {
          required: true,
        },
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
};

export default awsConfig;
